import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { FaClock, FaExclamationCircle } from "react-icons/fa";
import useSubscriptionExpired from "../../../hooks/useSubscriptionExpired";
import SubscriptionPay from "./SubscriptionPay";

const MODAL_KEY = "subscription_modal_snooze_until";

function getSnoozeUntil() {
  const value = localStorage.getItem(MODAL_KEY);
  return value ? new Date(value) : null;
}

function setSnooze(popUpShowInterval) {
  // const until = new Date(Date.now() + hours * 60 * 60 * 1000);
  const until = new Date(Date.now() + popUpShowInterval);
  localStorage.setItem(MODAL_KEY, until.toISOString());
}

const SubscriptionDuePopUp = () => {
  const [show, setShow] = useState(false);

  const { isExpiredPopUpShow, isFinalExpired, softwareInformation } =
    useSubscriptionExpired();

  // popUpShowInterval as minutes, so convert to miliseconds

  const popUpShowIntervalInMiliseconds =
    (softwareInformation?.pop_up_show_interval || 1) * 60 * 1000;

  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (isExpiredPopUpShow) {
      const snoozeUntil = getSnoozeUntil();

      if (!snoozeUntil || new Date() > snoozeUntil) {
        setShow(true);
      }
    }
    const timeout = setTimeout(() => {
      setRefresh(!refresh);
    }, popUpShowIntervalInMiliseconds);

    return () => clearTimeout(timeout);
  }, [isExpiredPopUpShow, refresh, popUpShowIntervalInMiliseconds]);

  const handleLater = () => {
    setSnooze(popUpShowIntervalInMiliseconds);

    setShow(false);
  };

  return (
    <div>
      <Modal
        show={show}
        backdrop="static"
        centered
        className="subscription-modal"
      >
        <Modal.Header className="border-0">
          <Modal.Title className="w-100 text-center">
            <FaExclamationCircle
              className="text-warning mb-3"
              style={{ fontSize: "13rem" }}
              size={60}
            />
            <h4 className="mb-0">Subscription Expired</h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center px-4">
          <p className="mb-4" style={{ fontSize: "1.1rem", color: "#666" }}>
            Your subscription has expired. Please pay to continue using the
            software.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-center pb-4">
          <SubscriptionPay />

          {!isFinalExpired && (
            <Button
              variant="outline-secondary"
              onClick={handleLater}
              className="px-4 py-2"
              style={{
                minWidth: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <FaClock />
              Later
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubscriptionDuePopUp;
